import React from 'react'
import { connect } from 'react-redux'
import AddToTrolleyButton from './AddToTrolleyButton'
import getMaximumQuantity from '../../helpers/getMaximumQuantity'

const AddToTrolleyButtonContainer = props => <AddToTrolleyButton {...props} />

export const mapStateToProps = (state, ownProps) => {
  const { availability = { data: {} }, trolley } = state
  const {
    hasAvailabilityInfo,
    trolleyButtonMainOptions,
    trolleyButtonTrackingParams,
    trolleyQuantityOptions,
    warrantyPartNumber,
    isTuTestVariant
  } = ownProps
  const { partNumber } = trolleyButtonMainOptions
  const { quantityAvailable } = availability.data[partNumber] || {
    quantityAvailable: trolleyQuantityOptions.maximumQuantity || 0
  }
  const maximumQuantity = availability.meta.errorDetail
    ? 10
    : getMaximumQuantity(hasAvailabilityInfo, quantityAvailable, 10)

  const partNumbers = warrantyPartNumber ? [[warrantyPartNumber, partNumber]] : []
  const isEnabled = !availability.meta.requestDone || !!availability.meta.errorDetail || quantityAvailable > 0

  const quantityCount = isTuTestVariant ? 1 : trolley?.[partNumber]?.quantity

  const buttonProps = { ...trolleyButtonMainOptions, isEnabled }

  const quantityProps = {
    ...trolleyQuantityOptions,
    isEnabled,
    maximumQuantity,
    partNumber,
    partNumbers,
    hideDropdown: isTuTestVariant
  }

  const props = {
    buttonProps,
    quantityProps,
    quantityCount,
    trolleyButtonTrackingParams,
    isTuTestVariant
  }
  return props
}

export default connect(mapStateToProps)(AddToTrolleyButtonContainer)
